import { MockFactory } from '@tino-frontend/mocks'
import { GeneratePixCodeResponse } from '@types'

export const paymentPixCode = new MockFactory<GeneratePixCodeResponse>({
  pix_emv_code:
    '00020126570014br.gov.bcb.pix0111811177100250220testede envio de pix52040000530398654041.235802BR5914testechave cpf6008saopaulo62070503***6304E067',
  created_at: new Date().toISOString(),
})
